import { MAIN_GAME_SCREEN, SETTINGS_SCREEN } from '../constants/routes';

export const routesExemptFromHistory = [SETTINGS_SCREEN];
export const routesTriggerAlertOnBack = [MAIN_GAME_SCREEN];
export const routesInterceptedOnBack = {};

export const getNewHistoryAndBackRoute = history => {
    const lastScreen = history[history.length - 2];
    const newHistory = history.slice(0, -1);

    if (routesExemptFromHistory.includes(lastScreen)) {
        return getNewHistoryAndBackRoute(newHistory);
    } else {
        return {
            currentRoute: lastScreen,
            history: newHistory,
        };
    }
};
